import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { GameConfigObj, GameSessionSubmit } from 'types/gameSession';
import API from './api';


/**
* @description Fetch Game Config
*
* @returns {Promise<AxiosResponse<GameConfigObj>>} - Game Config Map
* @example fetchGameSessionConfig()
*/
export async function fetchGameSessionConfig(): Promise<AxiosResponse<{ gameSessionConfigurationsMap: GameConfigObj }>> {
    const config: AxiosRequestConfig = {
        method: 'GET',
        url: '/game-session/configurations',
    };

    return await API.request<{ gameSessionConfigurationsMap: GameConfigObj }>(config)
}

/**
* @description Submit Game Session
*
* @param {GameSessionSubmit} gameSessionInfo - Game Session informations 
*
* @returns {Promise<void>} 
* @example submitGameSession()
*/
export async function submitGameSession(gameSessionInfo: GameSessionSubmit): Promise<void> {
    const config: AxiosRequestConfig = {
        method: 'POST',
        url: '/game-session',
        data: {
            ...gameSessionInfo
        }
    };

    // Returns `Ok`
    await API.request(config)
}
